import React from 'react';
import Gallery from '../components/Gallery';
import { photoVideographyImages } from '../data/images';

const PhotoVideography = () => {
  return (
    <div className="gallery-page">
      <section 
        className="hero-half"
        style={{
          backgroundImage: `url('/images/dvi-hero.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="hero-content">
          <h1>Photography & Videography</h1>
          <p>
            Complete photography and videography services capturing every moment with professional quality and creative excellence. 
            From intimate portraits to grand events, we deliver stunning visual stories.
          </p>
        </div>
      </section>
      
      <section className="gallery-section">
        <div className="container">
          <Gallery images={photoVideographyImages} sectionId="photo-videography" />
        </div>
      </section>

    </div>
  );
};

export default PhotoVideography;
